import { render, staticRenderFns } from "./list-wrapper.vue?vue&type=template&id=6c902946"
import script from "./list-wrapper.vue?vue&type=script&lang=js"
export * from "./list-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c902946')) {
      api.createRecord('6c902946', component.options)
    } else {
      api.reload('6c902946', component.options)
    }
    module.hot.accept("./list-wrapper.vue?vue&type=template&id=6c902946", function () {
      api.rerender('6c902946', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/contact-list-index/contact-list/list-wrapper.vue"
export default component.exports